import {useEffect} from 'react';
import {consent} from 'pageflow/frontend';
import {setupConsentPersistence, handleConsentRequested} from '../../usercentrics';
import {frontend, useAdditionalSeedData} from 'pageflow-scrolled/frontend';

// Pageflow expects to find a CSS file for each widget
import './empty.css';

setupConsentPersistence(consent);

frontend.widgetTypes.register('usercentricsConsentDialog', {
  component: function UsercentricsConsentDialog() {
    const usercentrics = useAdditionalSeedData('usercentrics');

    useEffect(() => {
      handleConsentRequested({
        consent,
        usercentricsSettingsId: usercentrics.settingsId
      });
    }, [usercentrics]);

    return null;
  }
});
